const gridItemsWrapper = document.querySelector('.ourWork__wrapper');
const gridItems = document.querySelectorAll('.workSample');
const breakpoint_md = 800;
const breakpoint_lg = 1024;

function setGrid() {
  if (!gridItemsWrapper || !gridItems.length) {
    return;
  }

  const windowLength = document.documentElement.clientWidth;

  if (windowLength < breakpoint_md) {
    gridItemsWrapper.style.gridTemplateRows = `repeat(${gridItems.length}, 228px)`;
    return;
  }

  if (windowLength >= breakpoint_md && windowLength < breakpoint_lg) {
    gridItemsWrapper.style.gridTemplateRows = 'repeat(auto-fit, minmax(57px, 1fr))';
    return;
  }

  gridItemsWrapper.style.gridTemplateRows = 'repeat(auto-fit, minmax(114px, 1fr))';
}

window.addEventListener('resize', setGrid);
window.addEventListener('load', setGrid);
